// extracted by mini-css-extract-plugin
export default {"container":"SetupIPACategoryLevelsCategoryMargin_container__Rrg-e"};